import { useQuery } from '@tanstack/react-query';
import { getDataDefault } from './getDataDefault';

interface UseGetDataParams {
  path: string;
  id?: string;
  query?: string;
  enabled?: boolean;
}

const useGetData = (route: UseGetDataParams) => {
  return useQuery({
    queryKey: [route.path, route.id, route.query],
    queryFn: () => getDataDefault(route.path, route.id, route.query),
    enabled: route.enabled ?? !!route.path,
    retry: 3,
  });
};

export default useGetData;
